import { apiClient } from '@app/api';

/**
 * Builds the HLS playlist URL for a bounded station recording range (logger VOD).
 * Adds 1 ms to `from` so the API does not return the previous segment.
 */
export function buildStationRangeHlsUrl(stationId: string, from: number, to: number): string {
  return apiClient.generateUrl(`/segments/stations/${stationId}/hls?from=${from + 1}&to=${to}`, {
    secure: true,
  });
}
